module.exports = __webpack_public_path__ + "img/黑色背景图2.513506b2.jpg";